import { useCallback, useEffect, useState } from "react";
import { api, errorText } from "@/lib/api";

export function useLets() {
  const [lets, setLets] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    try {
      setLets((await api.get("/lets")).data);
      setError("");
    } catch (err) {
      if (err?.response?.status !== 401) setError(errorText(err));
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  return { lets, error, load };
}
